import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* attachmentDownload(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ATTACHMENT_DOWNLOAD_REQUEST
    });

    const res = yield call(Http.get, `attachment/${action.payload?.attachmentId}/download`);

    yield put({
      type: Constants.GLOBAL_ATTACHMENT_DOWNLOAD_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ATTACHMENT_DOWNLOAD_FAILURE
    });
  }
}

export function* watchAttachmentDownload() {
  yield takeEvery(Constants.GLOBAL_ATTACHMENT_DOWNLOAD_START, attachmentDownload);
}
